// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"g","attrs":{},"children":[{"tag":"path","attrs":{"stroke":"#000","d":"M21 4H3V10H21V4Z M21 14H3V20H21V14Z","strokeWidth":"props.strokeWidth","fill":"none"}}]}]}]},{"tag":"g","attrs":{"id":"component-space"},"children":[{"tag":"g","attrs":{"id":"fill1","mask":"props.overlapMaskUrl_fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 4H3V10H21V4Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 14H3V20H21V14Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21 4H3V10H21V4Z M21 14H3V20H21V14Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const ComponentSpaceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-space',
    ref,
    icon: element,
  },
));

ComponentSpaceIcon.displayName = 'ComponentSpaceIcon';

export default ComponentSpaceIcon;
